import { render, staticRenderFns } from "./PictureOverview.vue?vue&type=template&id=64c96c04&"
import script from "./PictureOverview.vue?vue&type=script&lang=js&"
export * from "./PictureOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports